import navbar from "./components/navbar";
import categoryMenu from "./components/categoryMenu";
import sliderPagination from "./components/sliderPagination";

import pageHomeSlider from "./pages/pageHomeSlider";
import pageHomeCheckbox from "./pages/pageHomeCheckbox";
import pageProductCorrelati from "./pages/pageProductCorrelati";
import pageProductTab from "./pages/pageProductTab";
import pageProductInfo from "./pages/pageProductInfo";
import pageShippingConditions from "./pages/pageShippingConditions";

navbar();
categoryMenu();
sliderPagination();

pageHomeSlider();
pageHomeCheckbox();
pageProductCorrelati();
pageProductTab();
pageProductInfo();
pageShippingConditions();
